import { render } from "./FormLoader.vue?vue&type=template&id=57c8c7dc&scoped=true"
import script from "./FormLoader.vue?vue&type=script&lang=js"
export * from "./FormLoader.vue?vue&type=script&lang=js"

import "./FormLoader.vue?vue&type=style&index=0&id=57c8c7dc&lang=scss&scoped=true"

import exportComponent from "C:\\BEST develop\\EJF\\best_ejf15\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c8c7dc"]])

export default __exports__